import type { ReportDraft } from "./reportDraftApi";

export const MAX_REPORT_IMPORT_BYTES = 2 * 1024 * 1024;

export function importFileError(file: {
  name: string;
  size: number;
}): string | null {
  if (!/\.xlsx$/i.test(file.name)) return "Зөвхөн .xlsx файл сонгоно уу.";
  if (file.size === 0) return "Сонгосон файл хоосон байна.";
  if (file.size > MAX_REPORT_IMPORT_BYTES)
    return "Файл 2 MiB-ээс ихгүй байх ёстой.";
  return null;
}

// Convert file bytes, not Unicode text. The original XLSX is kept intact.
export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let offset = 0; offset < bytes.length; offset += 0x8000) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + 0x8000));
  }
  return btoa(binary);
}

export function importContextKey(
  report: ReportDraft,
  latest: ReportDraft | undefined,
  dirty: boolean,
): string {
  return JSON.stringify([
    report.orderListId,
    report.version,
    report.state,
    report.batchStatus,
    report.sourceHash,
    report.liveSourceHash,
    report.sourceChanged,
    latest?.version,
    latest?.state,
    latest?.batchStatus,
    latest?.sourceHash,
    latest?.liveSourceHash,
    latest?.sourceChanged,
    dirty,
  ]);
}

// A monotonic generation prevents late preview responses from becoming valid
// again when the form is edited and then reverted to its previous values.
export function createImportPreviewGuard() {
  let context = "";
  let generation = 0;
  return {
    setContext(next: string) {
      if (next !== context) {
        context = next;
        generation++;
      }
    },
    invalidate() {
      generation++;
    },
    capture() {
      return generation;
    },
    isCurrent(token: number) {
      return token === generation;
    },
  };
}

export const matchLabels: Record<string, string> = {
  Matched: "Таарсан",
  Unmatched: "Таараагүй",
  Ambiguous: "Нэг утгатай таараагүй",
};
export const importActionLabels: Record<string, string> = {
  Fill: "Дутуу утгыг нөхөх",
  Keep: "Өмнөх утгыг хадгалах",
  Match: "Ижил утга",
  Conflict: "Зөрүүтэй",
  Missing: "Утга дутуу",
  Unsupported: "Дэмжихгүй талбар",
};
